/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { useEffect, useContext } from "react";
import { Navigate, Routes, Route, useLocation } from "react-router-dom";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import ContextApp from "../core/contexts/context.app";
import Login from "./pages/Auth/Login";
import Logout from "./pages/Auth/Logout";
import Register from "./pages/Auth/Register";
import ServiceApi from "../core/services/service.api";
import ForgotPassword from "./pages/Auth/ForgotPassword";


function ProtectedRoute({ isAuthorized, children }) {
  return isAuthorized ? children : <Navigate to="/register" replace />;
}
export function Routes2() {
  let location = useLocation();
  const ctx = useContext(ContextApp);
  let isAuthorized = ServiceApi.hasToken();

  useEffect(() => {
    //بهتر از استورج گرفته شود تا در تمام صفحات مرورگر یکسان باشد
    isAuthorized = ServiceApi.hasToken();
    if (isAuthorized != ctx.isAuth && !isAuthorized) {
      ctx.setIsAuth(isAuthorized);
    }
  }, [location]);

  // const {isAuthorized} = useSelector(
  //     ({auth}) => ({
  //         isAuthorized: auth.user != null,
  //     }),
  //     shallowEqual
  // );

  return (
    <Routes>
      <Route path="/logout" element={<Logout />} />
      <Route path="/error" element={<ErrorsPage />} />
      <Route path="/forgotPassword" element={<ForgotPassword />} />

      {!isAuthorized ? (
        <>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
        </>
      ) : (
        <>
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/register" element={<Navigate to="/" replace />} />
        </>
      )}

      {isAuthorized ? (
        <Route
          path="*"
          element={
            <Layout>
              <BasePage />
            </Layout>
          }
        />
      ) : (
        <Route path="*" element={<Navigate to="/login" replace />} />
      )}
    </Routes>
  );
}
